import watchUltraLarge from '../../assets/images/logos/watch ultra large.png';
import watchUltraMedium from '../../assets/images/logos/watch ultra medium.png';
import watchUltraSmall from '../../assets/images/logos/watch ultra small.png';

import watchSeries8Large from '../../assets/images/logos/watch series8 large.png';
import watchSeries8Medium from '../../assets/images/logos/watch series8 medium.png';
import watchSeries8Small from '../../assets/images/logos/watch series8 small.png';

import m2Large from '../../assets/images/logos/m2 large.png';
import m2Medium from '../../assets/images/logos/m2 medium.png';
import m2Small from '../../assets/images/logos/m2 small.png';

import tv4kLarge from '../../assets/images/logos/tv4k large.png';
import tv4kMedium from '../../assets/images/logos/tv4k medium.png';
import tv4kSmall from '../../assets/images/logos/tv4k small.png';

import watchSeLarge from '../../assets/images/logos/watch se large.png';
import watchSeMedium from '../../assets/images/logos/watch se medium.png';
import watchSeSmall from '../../assets/images/logos/watch se small.png';

export const logoImages = {
	firstLogo: {
		large: watchUltraLarge,
		medium: watchUltraMedium,
		small: watchUltraSmall,
	},
	secondLogo: {
		large: watchSeries8Large,
		medium: watchSeries8Medium,
		small: watchSeries8Small,
	},
	thirdLogo: {
		large: m2Large,
		medium: m2Medium,
		small: m2Small,
	},
	fourthLogo: {
		large: tv4kLarge,
		medium: tv4kMedium,
		small: tv4kSmall,
	},
	fifthLogo: {
		large: watchSeLarge,
		medium: watchSeMedium,
		small: watchSeSmall,
	},
};
